import React from 'react';
import { Helmet } from 'react-helmet';
import '../styles/Testimonials.css';

const Testimonials: React.FC = () => {
  return (
    <section className="section testimonials">
      <meta name="google-site-verification" content="-3OTkhrHOCPlRzytSpxkqC08r3O4M8aOpN0h9XbZSnA" />
      <Helmet>
        <title>燒石鼎 | 顧客評價</title>
        <meta name="description" content="查看顧客對燒石鼎的評價，了解他們對我們食物和服務的滿意程度。" />
      </Helmet>
      <h2>顧客評價</h2>
      <p>顧客評價內容在此顯示。</p>
    </section>
  );
}

export default Testimonials;
